import { LogLevel } from '@nts/std/src/lib/utility';

export const environment = {
  production: true,
  baseAppUrl: 'https://ntslicensemanagement.ntsinformatica.it/',
  authenticationAppUrl: 'https://ntsloginservice.ntsinformatica.it/auth/login',
  prefixApi: '/api',
  envType: 'DEV',
  appTitle: 'LicenseManagement - DEV',
  appSubTitle: '',
  logLevel: LogLevel.All,
  isEnterpriseBarrierRequired: false
};
